import React from 'react';
import { styled } from '@components-shared/src/stitches';
import { InfoTooltip } from '@components/main-components/tooltip/InfoTooltip';
import { MediaQuery } from '@context/mediaQuery';
import { DataTestId } from '@utils/test';
import { CollectingFrozenInfo, NoLiquidityInfo } from './TooltipTextInfo';

export const CollectingNotAvailable = () => {
  const { tabletLandscape } = MediaQuery.useContainer();
  return (
    <TextInfoContainer data-testid={DataTestId.BONDING_CURVE_COLLECTING_UNAVAILABLE}>
      <p>Collecting is currently not available</p>
      <InfoTooltip delayCloseMs={1000} openOnClick={!tabletLandscape} variant="outlined" size={16}>
        <CollectingFrozenInfo />
      </InfoTooltip>
    </TextInfoContainer>
  );
};

export const SellingNotAvailable = () => {
  const { tabletLandscape } = MediaQuery.useContainer();

  return (
    <TextInfoContainer data-testid={DataTestId.BONDING_CURVE_SELLING_UNAVAILABLE}>
      <p>Selling is currently not available</p>
      <InfoTooltip delayCloseMs={1000} openOnClick={!tabletLandscape} variant="outlined" size={16}>
        <NoLiquidityInfo />
      </InfoTooltip>
    </TextInfoContainer>
  );
};

export const OwnerSellingNotAvailable = () => {
  const { tabletLandscape } = MediaQuery.useContainer();

  return (
    <TextInfoContainer
      flexDirection="column"
      data-testid={DataTestId.BONDING_CURVE_OWNER_SELLING_UNAVAILABLE}
    >
      You currently cannot sell
      <br />
      <Wrapper>
        any editions
        <InfoTooltip
          delayCloseMs={1000}
          openOnClick={!tabletLandscape}
          variant="outlined"
          size={16}
        >
          <NoLiquidityInfo />
        </InfoTooltip>
      </Wrapper>
    </TextInfoContainer>
  );
};

const TextInfoContainer = styled('div', {
  height: 92,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  gap: 4,
  base: 'M',
  fontWeight: 500,

  variants: {
    flexDirection: {
      column: {
        gap: 'unset',
        flexDirection: 'column',
      },
    },
  },
});

const Wrapper = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 4,
});
